import { APP_INITIALIZER, NgModule, inject, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './shared/interceptors/error.interceptor';
import { SpinnerInterceptor } from './shared/interceptors/spinner.interceptor';
import { CoreModule } from './core/core.module';
import { provideTransloco } from '@ngneat/transloco';
import { TranslocoHttpLoader } from './transloco-loader';
import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';
import { TranslocoService } from '@ngneat/transloco';
import { CookieService } from 'ngx-cookie-service';
import { CommonEnum } from './shared/enums/common.enum';
import { SharedModule } from './shared/shared.module';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';

export function appInitializerFactory(translate: TranslocoService) {
  const cookieService = inject(CookieService);
  const lang = cookieService.get(CommonEnum.Language);
  if (lang) {
    return () => translate.load(lang);
  }
  return () => translate.load(environment.defaultLang);
}

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, SharedModule, CoreModule],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFactory,
      deps: [TranslocoService],
      multi: true,
    },
    provideTransloco({
      config: {
        availableLangs: environment.availableLangs,
        defaultLang: environment.defaultLang,
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    MessageService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
